// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3UXOK","content":"styles_content__fIH_0"};